import { PropertyPolicy } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

import ChevronDownIcon from '../../../../assets/icons/ChevronDown';
import ChevronUpIcon from '../../../../assets/icons/ChevronUp';
import ExpandableList from '../../../../components/ExpandableList';
import colors from '../../../../constants/colors';
import useAnalytics from '../../../../hooks/useAnalytics';

interface Props {
  data: PropertyPolicy['propertyEndorsements'];
}

const Endorsements: React.FC<Props> = ({ data }: Props) => {
  const { track } = useAnalytics();
  const content = (isExpanded: boolean) => (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{
        p: 2,
        width: 1,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          fontSize: { mobile: '16px', tablet: '18px' },
          lineHeight: '24px',
        }}
      >
        Endorsements
      </Typography>
      <Stack
        sx={{
          background: 'rgba(11, 20, 33, 0.1)',
          cursor: 'pointer',
          p: 0.5,
          height: 'fit-content',
          borderRadius: 1,
        }}
      >
        {isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </Stack>
    </Stack>
  );

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: colors.csaaBorder,
        borderRadius: 2,
      }}
    >
      <ExpandableList
        content={content}
        id="endorsements"
        onClick={(isOpen) =>
          track('Endorsements Details Toggled', {
            event_type: 'UX Modified',
            location: 'Feature Card',
            link: 'Endorsements',
            selection: isOpen ? 'Closed' : 'Opened',
          })
        }
      >
        <Stack
          data-testid="endorsements-container"
          direction="column"
          spacing={1}
          sx={{
            padding: 2,
            backgroundColor: colors.csaaNeutralBackground,
            borderTop: '1px solid',
            borderColor: colors.csaaBorder,
            borderBottomRightRadius: 8,
            borderBottomLeftRadius: 8,
          }}
        >
          {data &&
            data
              .filter((item) => item.formIncluded)
              .map((item, idx) => (
                <Stack
                  key={`${item.formDescription}-${idx}`}
                  spacing={1}
                  direction="row"
                  justifyContent="space-between"
                  sx={{
                    fontFamily: 'Cabin',
                    fontKerning: 'normal',
                    backgroundColor: 'white',
                    padding: { mobile: 2, tablet: 3 },
                    boxShadow: `inset 0px 0px 0px 1px ${colors.csaaNeutral}`,
                    borderRadius: 2,
                    fontSize: { mobile: '16px', tablet: '18px' },
                  }}
                >
                  <Box sx={{ textAlign: 'left' }}>
                    <Typography
                      sx={{
                        lineHeight: '24px',
                        fontWeight: 700,
                      }}
                    >
                      {item.formDescription}
                    </Typography>
                  </Box>

                  <Typography
                    sx={{
                      lineHeight: '24px',
                      fontWeight: 700,
                    }}
                  >
                    Included
                  </Typography>
                </Stack>
              ))}
        </Stack>
      </ExpandableList>
    </Box>
  );
};

export default Endorsements;
